module.exports = __webpack_public_path__ + "static/UNITY-TOWER-1st-floor-traditional_v2-en-5ff05aaed82be0dcf82f4af0e0820321.pdf";